export class ColumnValueDistribution {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dbName",
            "baseName": "dbName",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaName",
            "baseName": "schemaName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "string",
            "format": ""
        },
        {
            "name": "columnName",
            "baseName": "columnName",
            "type": "string",
            "format": ""
        },
        {
            "name": "valueCount",
            "baseName": "valueCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lengthMin",
            "baseName": "lengthMin",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lengthMax",
            "baseName": "lengthMax",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lengthSum",
            "baseName": "lengthSum",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "lengthBuckets",
            "baseName": "lengthBuckets",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "shapeMasks",
            "baseName": "shapeMasks",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "shapeCounts",
            "baseName": "shapeCounts",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "shapeErrorBound",
            "baseName": "shapeErrorBound",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "valueEncoding",
            "baseName": "valueEncoding",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceType",
            "baseName": "sourceType",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowCount",
            "baseName": "rowCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "nullCount",
            "baseName": "nullCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "emptyCount",
            "baseName": "emptyCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "numericKind",
            "baseName": "numericKind",
            "type": "string",
            "format": ""
        },
        {
            "name": "numericCount",
            "baseName": "numericCount",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "numericBuckets",
            "baseName": "numericBuckets",
            "type": "Array<number>",
            "format": "int64"
        },
        {
            "name": "cardinality",
            "baseName": "cardinality",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "repetitionBuckets",
            "baseName": "repetitionBuckets",
            "type": "Array<number>",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return ColumnValueDistribution.attributeTypeMap;
    }
    constructor() {
    }
}
